(function ($, Drupal) {
	Drupal.behaviors.keydocumentsearch = {
        attach: function (context, settings) {
            // jQuery('.bam-filter-form .clearfilter').on('click',function(){
            //     jQuery(this).closest('.fieldset').find('input').prop('checked', '');
            //     jQuery(this).closest('.filter-wrapper').find('.form-submit').trigger('click');
            //     jQuery(this).prev('.fieldset-legend').text('Any');
            //     jQuery(this).remove(); 
            // });
                       
            // jQuery('.bam-filter-form .fieldset .fieldset-title').on('click', function (event) {
            //     if(window.matchMedia('(min-width:1025px)').matches){
            //         jQuery(this).closest('.fieldset').find('.col-xs-12').niceScroll('.form-checkboxes',{
            //         //jQuery(".bam-filter-form .fieldset .fieldset-wrapper .col-xs-12").niceScroll('.form-checkboxes',{
            //             cursoropacitymin:0.2,
            //             cursorcolor:'#0f3557',
            //             cursorborder:'none',
            //             cursorborderradius:4,
            //             cursoropacitymax: 0.3,
            //             horizrailenabled:false,
            //             cursorwidth:8,
            //             scrollspeed: 30,
            //             mousescrollstep: 20, 
            //         }).resize();
            //     }
            // });

        }
    };
})(jQuery, Drupal);


jQuery(document).ready(function() {

//     jQuery('.fieldset .fieldset-title').on('click', function (event) {
//         if(window.matchMedia('(min-width:1025px)').matches){
//             jQuery(".bam-filter-form .fieldset .fieldset-wrapper [class^=col]").niceScroll('.form-checkboxes',{
//                 cursoropacitymin:0.2,
//                 cursorcolor:'#0f3557',
//                 cursorborder:'none',
//                 cursorborderradius:4,
//                 cursoropacitymax: 0.3,
//                 horizrailenabled:false,
//                 cursorwidth:8,
//                 scrollspeed: 30,
//                 mousescrollstep: 20, 
//             }).resize();
//         }
//     });
    
    
//    /*nice scroll for filter dropdown */
//    if(window.matchMedia('(min-width:1025px)').matches){
//     jQuery(".bam-filter-form .fieldset .fieldset-wrapper [class^=col]").niceScroll('.form-checkboxes',{
//             cursoropacitymin:0.2,
//             cursorcolor:'#0f3557',
//             cursorborder:'none',
//             cursorborderradius:4,
//             cursoropacitymax: 0.3,
//             horizrailenabled:false,
//             cursorwidth:8,
//             scrollspeed: 30,
//             mousescrollstep: 20, 
//         }).resize();
//     }
});